import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { observer } from 'mobx-react-lite';
import { CustomerMessageDownload } from '@codefluegel/wowis-rest-typescript-client';
import { Typography } from '@mui/material';
import moment from 'moment';

const MessageModal = observer(
  ({
    open,
    onClose,
    message,
  }: {
    open: boolean;
    message: CustomerMessageDownload | null;
    onClose: () => void;
  }): JSX.Element => (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle color="#58585A">{message?.title}</DialogTitle>
      <DialogContent sx={{ minWidth: 400, width: 400 }}>
        <Typography
          color="secondary"
          variant="inherit"
          sx={{
            fontSize: 12,
            fontWeight: 'light',
            lineHeight: '1.5rem',
          }}
        >
          {moment(message?.createdAt).format('DD.MM.YYYY')}
        </Typography>
        {message?.body}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  ),
);

export default MessageModal;
